export const entitiesRoute = 'entities'
export const entityRoute = 'entities'
export const addRoute = 'add'
export const viewRoute = 'view'
export const tabRoute = 'tab'
export const editRoute = 'edit'
export const view360Route = '360view'
export const callRoute = 'interaction'
export const permissionAssignmentRoute = 'permission-assignment'
